/* eslint-disable max-len */
import React from 'react';
import '../css/UpdatesBlock.css';

/**
 * The updates block component used for mid-page content
 * @component UpdatesBlock
 * @return {component} UpdatesBlock component
 */
export default function UpdatesBlockFull() {
  return (
    <div className="updates-root">
      <div className="updates-container">
        <div className="updates-overlay">
          <div className="updates-content">
            <h3 style={{fontSize: '30px'}}>
              2023-24 University Partnerships Available With Advanced
              Intelligence Services Corporation
            </h3>
            <p>
              Advanced Intelligence Services Corporation offers robust academic
              partnerships with graduate-level Universities to encourage the
              development and promotion of accelerated physics research
              throughout the twenty-first century international science
              community. Student and graduate internship program opportunities
              are available for college-level physicists in technology design
              and management, advanced research and information product
              development, and business administration.
            </p>
            <p>
              Our primary research focuses include pre-expression matter
              development, expression, distribution and exhaust-pollution; the
              synthesis of algorithmic waves producing solid matter; non-linear
              physics; metabolic physics; artificial physics conceptualization;
              next-generation astrophysics theories and hypotheses; as well as
              innovative use potentials for these topics.
            </p>
            <p>
              College physics program managers and administrators are encouraged
              to contact Advanced Intelligence Services Corporation for current
              program requirements. Enrollment is available on a rolling basis,
              and participation availability is limited.
            </p>
            <br />
            <br />
            {/* <a draggable="false" className="updates-button" href={WhitePaper}> */}
            <a draggable="false" className="updates-button" href="/support">
              Connect With AIS
            </a>
          </div>
        </div>
      </div>
      <div style={{height: '50px', opacity: '0.1'}} />
      <div className="updates-component">
        <div className="updates-mission-container">
          <h1>MISSION STATEMENT</h1>
          <br />
          <h2 className="updates-mission-text">
            The mission of the Advanced Intelligence Services Corporation is to
            maximize the safety and security of the United States of America,
            it's people and, whenever possible, it's global partners, long-term,
            through the ethical achievement of core asset defense management and
            the total cooperation of America’s progressive biodefense goals,
            objectives, and tasks in the twenty-first century and beyond.
          </h2>
        </div>
        <div className="updates-mission-extended">
          <div className="updates-mission-item">
            <h1>What We Do</h1>
            <p>
              The Advanced Intelligence Services Corporation conducts
              accelerated biophysics research and directs special project
              development to resolve the many emerging biodefense challenges of
              the United States Department of Defense, including metabolic
              physics warfare.
            </p>
          </div>
          <div className="updates-mission-item">
            <h1>Our Network</h1>
            <p>
              Our skill network is comprised of experts in business
              administration, technology, security, government, and psychology,
              each devoted to superior national security through scientific
              excellence. Together, our organization performs rigorous
              operations protocols and advances biodefense technologies that
              help America succeed as a frontrunner in economics, education and
              science.
            </p>
          </div>
          <div className="updates-mission-item">
            <h1>Our Vision</h1>
            <p>
              The Advanced Intelligence Services Corporation embraces a central
              service vision for excellence, durability, and the long-term
              maximization of America's future unlike any other defense
              corporation in history. Based on next-generation advancements in
              non-linear physics, pre-expression matter concepts, and true
              multi-circa operating, we are confident in our nation's military
              and industrial futures, in and beyond modern biotechnology
              marketplace.
            </p>
          </div>
        </div>
      </div>
      <div style={{height: '50px', opacity: '0.1'}} />
      <div className="updates-component-bottom">
        <h1>Our History</h1>
        <p>
          In the beginning, there was inspiration. Following the tragic events
          of 2001, Jim D. Ray, Jr., a 21-year-old commercial real estate broker,
          set out on an educational journey to explore common career options,
          ultimately discovering more than he could have imagined. In the end,
          the realities of life and death led Ray, an accelerated college
          student, to engage in modern physics research using a proprietary
          metric for cross-referencing critical facts between the fields of
          biology, metabolic physics, astrophysics, and most recently, the
          metaverse, an artificial physics (Virtual Reality) platform, to be
          introduced internationally in the near future.
        </p>
        <p>
          On March 03, 2010, the Advanced Intelligence Services Corporation was
          born. And with it, many facts, figures, and illustrations of physics
          were introduced to the world through Ray’s research label, and his
          increasingly rigorous approach to developing technology designed from
          core physics infrastructure.
        </p>
        <p>
          More than a dozen academic experts agree Ray has the drive, skillset,
          and perseverance to accomplish serious progress in his desired field
          of study, and career as a biotechnology defense contractor.
        </p>
        <p>
          Although history has witnessed many scientific conquests since Ray’s
          initial research, such as innovations in metabolic human interfacing,
          the total accomplishment belongs to the brave individuals who
          encouraged, supported, and worked together to manifest the results we
          so appreciate and revere today.
        </p>
        <p>
          “The veracity of the human organization involved in creating,
          developing, and engineering A.I.S. products is exceptional, very
          extraordinary. We have assembled a team that inspires courage,
          respect, and accuracy in the scientific exploration of our total
          Universe.” – Jim D. Ray, Jr., C.E.O.
        </p>
      </div>
    </div>
  );
}
